(() => {
  const init = (root) => {
    if (!root || root.dataset.ledgerReady === 'true') return;
    root.dataset.ledgerReady = 'true';

    const content = root.querySelector('[data-ledger-content]');
    const desktopList = root.querySelector('[data-ledger-toc]');
    const mobileList = root.querySelector('[data-ledger-mobile-toc]');
    const headings = content ? Array.from(content.querySelectorAll('h2')) : [];

    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `section-${index + 1}`;
      [desktopList, mobileList].forEach((list) => {
        if (!list) return;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        list.appendChild(item);
      });
    });

    content?.querySelectorAll('table').forEach((table) => {
      if (table.parentElement?.classList.contains('nl-ledger__table-wrap')) return;
      const wrap = document.createElement('div');
      wrap.className = 'nl-ledger__table-wrap';
      wrap.tabIndex = 0;
      wrap.setAttribute('role', 'region');
      wrap.setAttribute('aria-label', table.getAttribute('data-label') || 'Scrollable comparison table');
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });

    const progress = root.querySelector('[data-ledger-progress]');
    const updateProgress = () => {
      if (!progress || !content) return;
      const rect = content.getBoundingClientRect();
      const total = Math.max(content.offsetHeight - window.innerHeight, 1);
      const traveled = Math.min(Math.max(-rect.top, 0), total);
      progress.style.width = `${(traveled / total) * 100}%`;
    };

    const desktopLinks = desktopList ? Array.from(desktopList.querySelectorAll('a')) : [];
    if ('IntersectionObserver' in window && headings.length) {
      const observer = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
        if (!visible) return;
        desktopLinks.forEach((link) => link.setAttribute('aria-current', String(link.hash === `#${visible.target.id}`)));
      }, { rootMargin: '-15% 0px -70% 0px' });
      headings.forEach((heading) => observer.observe(heading));
    }

    updateProgress();
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
  };

  document.querySelectorAll('[data-ledger-root]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-ledger-root]')));
})();
